import { Component, OnInit } from '@angular/core';
import { TimetableService } from '../../services/elev-online.data.service';
import { MonthTimetable } from '../../models/event.model';
import { BookingModalComponent } from '../../gcsetimetable/booking-modal/booking-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-elev-plus-online',
    templateUrl: './elev-plus-online.component.html',
    styleUrls: ['./elev-plus-online.component.css'],
    standalone: false
})
export class ElevPlusOnlineComponent implements OnInit {

   months: string[] = [];
    selectedMonth: string = 'Online';
      timetable: MonthTimetable = {};
    
      constructor(private timetableService: TimetableService) {}
    
      ngOnInit() {
        this.months = this.timetableService.getMonths();
        this.timetable = this.timetableService.getTimetable();
      }
    
      selectMonth(month: string) {
        this.selectedMonth = month;
      }
  

}
